import { render } from "./SweetHome.vue?vue&type=template&id=6b86dd1d"
import script from "./SweetHome.vue?vue&type=script&lang=js"
export * from "./SweetHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__